<template>
  <div class="number-display-container">

    <div class="number-cards">
      <div class="number-card">
        <div class="number">{{ formattedCooperation }}</div>
        <div class="label">合作主持</div>
      </div>
      <div class="number-card">
        <div class="number">{{ formattedEvents }}</div>
        <div class="label">活动场次</div>
      </div>
      <div class="number-card">
        <div class="number">{{ formattedParticipants }}</div>
        <div class="label">参与人次</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'

export default {
  name: 'NumberDisplay',
  setup() {
    // 目标数值
    const targetCooperation = 19858
    const targetEvents = 29568
    const targetParticipants = 50123158
    
    // 当前显示的数值
    const currentCooperation = ref(0)
    const currentEvents = ref(0)
    const currentParticipants = ref(0)
    
    // 格式化数字，添加逗号分隔符
    const formatNumber = (num) => {
      return num.toLocaleString() + '+'
    }
    
    // 计算属性：格式化后的数字
    const formattedCooperation = computed(() => formatNumber(currentCooperation.value))
    const formattedEvents = computed(() => formatNumber(currentEvents.value))
    const formattedParticipants = computed(() => formatNumber(currentParticipants.value))
    
    // 动画函数
    const animateNumber = (current, target, duration = 3000) => {
      const startTime = Date.now()
      const startValue = current.value
      const changeValue = target - startValue
      
      const updateNumber = () => {
        const now = Date.now()
        const elapsed = now - startTime
        const progress = Math.min(elapsed / duration, 1)
        
        // 使用缓动函数使动画更自然
        const easeOutQuart = 1 - Math.pow(1 - progress, 4)
        current.value = Math.floor(startValue + changeValue * easeOutQuart)
        
        if (progress < 1) {
          requestAnimationFrame(updateNumber)
        } else {
          current.value = target
        }
      }
      
      requestAnimationFrame(updateNumber)
    }
    
    // 组件挂载后开始动画
    onMounted(() => {
      // 延迟一点时间开始动画，确保组件已渲染
      setTimeout(() => {
        animateNumber(currentCooperation, targetCooperation, 2000)
        animateNumber(currentEvents, targetEvents, 2500)
        animateNumber(currentParticipants, targetParticipants, 3000)
      }, 500)
    })
    
    return {
      formattedCooperation,
      formattedEvents,
      formattedParticipants
    }
  }
}
</script>

<style scoped>
.number-display-container {
  font-family: 'Arial', sans-serif;
  max-width: 1200px;
  margin: 0 auto;

  text-align: center;

}



.number-cards {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
}

.number-card {
  background: white;
  border-radius: 15px;
 

  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 1;
  min-width: 250px;
  max-width: 350px;
}

.number-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.number {
  font-size: 2.5rem;
  font-weight: 800;
   color:#CA4E78;
  margin-bottom: 15px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.label {
  font-size: 1.5rem;
    color:#CA4E78;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .number-cards {
  
    align-items: center;
  }
  
  .number-card {
    width: 100%;
    max-width: 300px;
  }
  
  .number {
    font-size: 2.8rem;
  }
  
  .title {
    font-size: 2rem;
  }
}
</style>